export default "__VITE_ASSET__BvD3MAVX__"